import { ReactElement } from "react";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import "./_UiaIconAR.scss";

type UiaIconARProps = {
  inverse?: boolean;
};

const UiaIconAR = ({ inverse = false }: UiaIconARProps): ReactElement => {
  const { projectClass } = useUiContext();

  const getClassName = () => classNames(`${projectClass}_UiaIconAR`, { inverse });

  return (
    <svg
      className={getClassName()}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="20.5 14.44 234.06 235.18"
      width={100}
    >
      <path
        opacity={1}
        d="M56.5 14.5v5c-10.514-.328-20.847.006-31 1v31h-5v-35c.11-.617.444-1.117 1-1.5 11.662-.5 23.329-.666 35-.5zM254.5 16.5v35h-5c.328-10.514-.006-20.847-1-31h-31v-6c12.005-.166 24.005 0 36 .5.556.383.889.883 1 1.5zM206.5 75.5c-3.871-.315-7.538.018-11 1a4137.555 4137.555 0 0 0-56-10v18c3.307-.55 6.64-.884 10-1v3h8c-5.774 1.446-11.774 2.112-18 2-.333 27.675 0 55.341 1 83a5179.823 5179.823 0 0 1 57 9c-1.548.321-2.215 1.321-2 3a1217.718 1217.718 0 0 1-52-7c-1.419-.951-3.085-1.284-5-1-.326 8.184.008 16.184 1 24a852.202 852.202 0 0 1 56-13v3h3c-20.513 4.986-41.18 9.986-62 15a1360.313 1360.313 0 0 1-61-15h5v-3a3074.33 3074.33 0 0 0 53 13 133.155 133.155 0 0 0 1-23 165.464 165.464 0 0 0-31 4c-4.896-1.946-10.23-2.613-16-2a5916.462 5916.462 0 0 0 47-7v-83c-6.854-.235-13.521-.902-20-2h11v-3c2.93.799 5.93 1.132 9 1v-18c-3.07-.132-6.07.201-9 1v-3h-6c6.711-2.3 13.711-3.133 21-2.5 22.239 3.98 44.239 8.48 66 13.5z"
      />
      <path
        opacity={1}
        d="M195.5 76.5c3.462-.982 7.129-1.315 11-1 2.619-.268 5.119.065 7.5 1 .667 36.333.667 72.667 0 109a105.823 105.823 0 0 1-15.5 4h-3v-3a28.208 28.208 0 0 1 4-1.5c-1.558-.21-2.891-.71-4-1.5-.215-1.679.452-2.679 2-3l12 1v-101a4841.299 4841.299 0 0 0-52 6h-8v-3a1081.918 1081.918 0 0 1 46-5.5c1.238-.69 1.238-1.19 0-1.5zM119.5 64.5h6v3a900.612 900.612 0 0 0-47 9.5c2.123 1.194 4.457 1.86 7 2a2437.013 2437.013 0 0 0 40 4.5v3h-11a3241.198 3241.198 0 0 1-50-6v101a954.358 954.358 0 0 1 23-3c5.77-.613 11.104.054 16 2a202.998 202.998 0 0 0-29 4.5 20.088 20.088 0 0 0 6 1.5v3h-5a45.78 45.78 0 0 1-15.5-4 2970.352 2970.352 0 0 1 0-109c19.821-4.054 39.655-8.054 59.5-12zM25.5 212.5v31h31v5h-35c-.667 0-1-.333-1-1v-35h5zM254.5 212.5c.167 12.005 0 24.005-.5 36a338.482 338.482 0 0 1-36.5 1v-6h31c.994-10.153 1.328-20.486 1-31h5z"
      />
    </svg>
  );
};

export default UiaIconAR;
